document.addEventListener('DOMContentLoaded', () => {
	if(document.querySelector('.b-cookies__button')) {
		document.querySelector('.b-cookies__button').addEventListener('click', () => {
			document.cookie = 'cookieAccepted=1; path=/; max-age=31536000;'
			document.querySelector('.b-cookies').classList.add('hidden')
		})
	}
})